var render = function render(){var _vm=this,_c=_vm._self._c;return _c('aside',{staticClass:"vuestic-sidebar"},[_c('vuestic-scrollbar',[_c('ul',{staticClass:"sidebar-menu"},[_vm._t("menu")],2)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }